import WindModel from "./wind";
const WindModels = {
  wind: WindModel
};
export default WindModels;